// Generated by BUCKLESCRIPT VERSION 2.2.2, PLEASE EDIT WITH CARE
'use strict';

var Cell = require("./cell");
var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Caml_exceptions = require("bs-platform/lib/js/caml_exceptions.js");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

var InvalidMove = Caml_exceptions.create("Board.InvalidMove");

function sortCells(param) {
  return List.sort((function (c1, c2) {
                return (Caml_int32.imul(c1[/* y */1], 10) + c1[/* x */0] | 0) - (Caml_int32.imul(c2[/* y */1], 10) + c2[/* x */0] | 0) | 0;
              }), param);
}

function initCells(width, height, color) {
  return Belt_List.makeBy(Caml_int32.imul(width, height), (function (i) {
                return /* record */[
                        /* x */Caml_int32.mod_(i, width),
                        /* y */Caml_int32.div(i, width),
                        /* color */color
                      ];
              }));
}

function drawCells(cells, cellsToDraw) {
  return sortCells(List.append(cellsToDraw, List.filter((function (cell) {
                          return 1 - List.exists((function (param) {
                                        if (param[/* x */0] === cell[/* x */0]) {
                                          return +(param[/* y */1] === cell[/* y */1]);
                                        } else {
                                          return /* false */0;
                                        }
                                      }), cellsToDraw);
                        }))(cells)));
}

function getCell(x, y, cells) {
  var exit = 0;
  var val;
  try {
    val = List.find((function (cell) {
            if (cell[/* x */0] === x) {
              return +(cell[/* y */1] === y);
            } else {
              return /* false */0;
            }
          }), cells);
    exit = 1;
  }
  catch (exn){
    if (exn === Caml_builtin_exceptions.not_found) {
      return /* None */0;
    } else {
      throw exn;
    }
  }
  if (exit === 1) {
    return val[/* color */2];
  }
  
}

function init(width, height) {
  var mw = width / 2 | 0;
  var mh = height / 2 | 0;
  var cells = drawCells(initCells(width, height, /* None */0), /* :: */[
        /* record */[
          /* x */mw,
          /* y */mh,
          /* color : Some */[/* Black */1]
        ],
        /* :: */[
          /* record */[
            /* x */mw - 1 | 0,
            /* y */mh - 1 | 0,
            /* color : Some */[/* Black */1]
          ],
          /* :: */[
            /* record */[
              /* x */mw - 1 | 0,
              /* y */mh,
              /* color : Some */[/* White */0]
            ],
            /* :: */[
              /* record */[
                /* x */mw,
                /* y */mh - 1 | 0,
                /* color : Some */[/* White */0]
              ],
              /* [] */0
            ]
          ]
        ]
      ]);
  return /* record */[
          /* width */width,
          /* height */height,
          /* cells */cells
        ];
}

function getCountForColor(board, color) {
  return List.length(List.filter((function (c) {
                      return Caml_obj.caml_equal(c[/* color */2], color);
                    }))(board[/* cells */2]));
}

var directions = /* :: */[
  /* tuple */[
    0,
    1
  ],
  /* :: */[
    /* tuple */[
      0,
      -1
    ],
    /* :: */[
      /* tuple */[
        1,
        0
      ],
      /* :: */[
        /* tuple */[
          1,
          1
        ],
        /* :: */[
          /* tuple */[
            1,
            -1
          ],
          /* :: */[
            /* tuple */[
              -1,
              0
            ],
            /* :: */[
              /* tuple */[
                -1,
                1
              ],
              /* :: */[
                /* tuple */[
                  -1,
                  -1
                ],
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

function isOutOfBound(param, param$1) {
  var y = param$1[1];
  var x = param$1[0];
  if (x < 0 || y < 0 || x > (param[/* width */0] - 1 | 0)) {
    return /* true */1;
  } else {
    return +(y > (param[/* height */1] - 1 | 0));
  }
}

function flippedCellsInDirection(board, cell, param) {
  var diry = param[1];
  var dirx = param[0];
  var cells = /* [] */0;
  var cursor = /* tuple */[
    cell[/* x */0] + dirx | 0,
    cell[/* y */1] + diry | 0
  ];
  var $$break = /* false */0;
  while(!$$break) {
    var cursor$1 = cursor;
    var y = cursor$1[1];
    var x = cursor$1[0];
    var tmp;
    if (isOutOfBound(board, cursor$1)) {
      $$break = /* true */1;
      tmp = /* [] */0;
    } else {
      var color = getCell(x, y, board[/* cells */2]);
      if (color) {
        if (Caml_obj.caml_equal(color, cell[/* color */2])) {
          $$break = /* true */1;
          tmp = cells;
        } else {
          cursor = /* tuple */[
            x + dirx | 0,
            y + diry | 0
          ];
          tmp = /* :: */[
            /* record */[
              /* x */x,
              /* y */y,
              /* color */cell[/* color */2]
            ],
            cells
          ];
        }
      } else {
        $$break = /* true */1;
        tmp = /* [] */0;
      }
    }
    cells = tmp;
  };
  return cells;
}

function getFlippedCells(board, cell) {
  var flipped = List.flatten(List.map((function (param) {
              return flippedCellsInDirection(board, cell, param);
            }), directions));
  if (flipped) {
    return /* :: */[
            cell,
            flipped
          ];
  } else {
    return /* [] */0;
  }
}

function availableCellChanges(board, color) {
  return List.filter((function (cell) {
                  var match = getFlippedCells(board, cell);
                  if (match) {
                    return /* true */1;
                  } else {
                    return /* false */0;
                  }
                }))(initCells(board[/* width */0], board[/* height */1], color));
}

function applyCellChange(board, cell) {
  var match = getCell(cell[/* x */0], cell[/* y */1], board[/* cells */2]);
  var cells;
  if (match) {
    throw InvalidMove;
  } else {
    var flipped = getFlippedCells(board, cell);
    if (flipped) {
      cells = drawCells(board[/* cells */2], flipped);
    } else {
      throw InvalidMove;
    }
  }
  return /* record */[
          /* width */board[/* width */0],
          /* height */board[/* height */1],
          /* cells */cells
        ];
}

var component = ReasonReact.statelessComponent("Board");

function make(board, onCellClick, _) {
  var cellWidth = Pervasives.string_of_float(100 / board[/* width */0]) + "%";
  var cells = $$Array.map((function (cell) {
          return React.createElement("div", {
                      key: Pervasives.string_of_int(cell[/* y */1]) + Pervasives.string_of_int(cell[/* x */0]),
                      style: {
                        width: cellWidth
                      }
                    }, ReasonReact.element(/* None */0, /* None */0, Cell.make(cell[/* color */2], (function () {
                                return Curry._1(onCellClick, cell);
                              }), /* array */[])));
        }), $$Array.of_list(board[/* cells */2]));
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "board"
                }, cells);
    });
  return newrecord;
}

exports.InvalidMove = InvalidMove;
exports.sortCells = sortCells;
exports.initCells = initCells;
exports.drawCells = drawCells;
exports.getCell = getCell;
exports.init = init;
exports.getCountForColor = getCountForColor;
exports.directions = directions;
exports.isOutOfBound = isOutOfBound;
exports.flippedCellsInDirection = flippedCellsInDirection;
exports.getFlippedCells = getFlippedCells;
exports.availableCellChanges = availableCellChanges;
exports.applyCellChange = applyCellChange;
exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/board.re
// module id = 30
// module chunks = 0